//External
import React from "react";
//Internal
import error500 from "../../public/assets/images/error-500.svg";

/*******************
  @Purpose : used for Error 500
  @Parameter : {}
  @Author : INIC
  *******************/
const Error500 = () => {
  /*******************
	@purpose : Render HTML/ React Components
	@Author : INIC
	******************/
  return (
    <>
      <div className="error-page py-60">
        <div className="custom-container">
          <div className="content-404 text-center">
            <div className="error-img">
              <img src={error500} width={"100%"} alt="404 Error img" />
            </div>
            <h2 className="mt-4 mt-sm-5 content-404-title ff-hel-reg">
              Oops 500
              <br />
              This is somewhat embarrassing, isn’t it?
            </h2>
          </div>
        </div>
      </div>
    </>
  );
};

export default Error500;
